<template>
  <div id="Tax-create" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue darken-2"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="errors = null" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-form ref="taxForm" v-model="valid" v-if="!loading">
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock :headerText="'Create Tax'" />
            <v-row>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Tax Code*</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <v-text-field
                    placeholder="Enter Tax Code*"
                    v-model="form.tax_code"
                    outlined
                    dense
                    required
                  />
                </v-col>
              </v-col>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Name*</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <v-text-field
                    v-model="form.name"
                    outlined
                    dense
                    required
                    placeholder="Enter Name*"
                  />
                </v-col>
              </v-col>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Rate (%)*</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <v-text-field
                    v-model="form.rate"
                    outlined
                    dense
                    type="number"
                    required
                    placeholder="Enter Rate (%)*"
                  />
                </v-col>
              </v-col>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Effective From</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <DatePicker
                    v-model="form.effective_from"
                    placeholder="Effective From"
                  />
                </v-col>
              </v-col>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Effective To</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <DatePicker
                    v-model="form.effective_to"
                    placeholder="Effective To"
                    :min="form.effective_from"
                  />
                </v-col>
              </v-col>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Status</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <v-autocomplete
                    v-model="form.status"
                    :items="['ACTIVE', 'INACTIVE']"
                    outlined
                    dense
                    clearable
                    placeholder="Select Status"
                  />
                </v-col>
              </v-col>
            </v-row>
            <v-col cols="12" md="12" sm="12">
              <v-card-actions class="mt-10">
                <v-row>
                  <v-col cols="12" md="10" xs="6"></v-col>
                  <v-col cols="12" md="2" xs="6">
                    <v-btn
                      large
                      color="#00B3FF"
                      dark
                      depressed
                      block
                      @click="submit"
                      :loading="loading"
                      :disabled="!valid"
                    >
                      Create Tax
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="snackbar = false"
    />
  </div>
</template>

<script>
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import Snackbars from "@/components/shared/Snackbars";
import Alert from "@/components/shared/Alert";
import { TaxService } from "@/services/tax-service.js";
import { checkError } from "@/config/errors.js";
import DatePicker from "@/components/shared/DatePicker.vue";

export default {
  name: "TaxCreateForm",
  components: { HeaderDividerBlock, Snackbars, Alert, DatePicker },
  data() {
    return {
      form: {
        tax_code: "",
        name: "",
        rate: "",
        status: "ACTIVE",
        effective_from: "",
        effective_to: "",
      },
      valid: false,
      loading: false,
      successMsg: "",
      snackbar: false,
      errors: null,
    };
  },
  methods: {
    submit() {
      this.loading = true;
      TaxService.createTax(this.form)
        .then(() => {
          this.successMsg = "Tax created successfully";
          this.snackbar = true;
          this.$router.push({ name: "TaxList" });
        })
        .catch((error) => {
          let data = error.response?.data;
          this.errors = checkError.errorFormatting(data);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
